import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";
import { findInWidgetState } from "./storeUtils";

//resolving binding for components which are not connected to store
// {dynamicItem} will be rеsolved using itemClassifier
//(added by parent in case of "item" config)
// presumption: {dynamicItem} is at the end of bindTo
export const resolveStaticBinding = function(
    bindTo = "",
    parentBindTo = "",
    index,
    itemClassifier
) {
    var result = bindTo;

    //by default return parentBindTo
    if (!bindTo) {
        return parentBindTo;
    }

    //check for relative binding
    if (result.includes("../")) {
        result = resolveRelativeBinding(result, parentBindTo);
    } else {
        result = resolveParentBinding(result, parentBindTo);
    }

    result = resolveItemBinding(result, index);

    //will resolve {dynamicItems} only if own data is available
    result = resolveDynamicItemsFromJSONData(result, index, itemClassifier);

    return result;
};

//Resolving complex binding
//{parent} -> provided parentBindTo
//{item} -> provided index
//{dynamicItem} -> used in collection items binding
//takes first class element from the collection item in provided index
export const resolveBinding = function(
    bindTo = "",
    parentBindTo = "",
    index,
    widgetImmutableData = false
) {
    var result = bindTo;

    //check for relative binding
    if (result.includes("../")) {
        result = resolveRelativeBinding(result, parentBindTo);
    } else {
        result = resolveParentBinding(result, parentBindTo);
    }

    result = resolveItemBinding(result, index);

    //in case the collection has no indexes in item's class
    //will not be resolved for components which are not connected to the store
    result = resolveDynamicItemsFromImmutableData(result, index, widgetImmutableData);

    return result;
};

function resolveParentBinding(bindingString, parentBindTo) {
    var result = bindingString;

    //Implementing placeholders in bindTo property
    //Collection components should provide props.parentBindTo to collection items
    if (result.includes("{parent}")) {
        if (!parentBindTo) {
            WEBUILogs.error("Missing props.parentBindTo");
        }

        result = result.replace("{parent}", parentBindTo);
    }

    return result;
}

//resolves relative binding (relative to parentBindTo)
//Example:
//bindingString: "../../download"
//parentBindTo: "claims.claim1.data.header"
//result: "claims.claim1.download"
function resolveRelativeBinding(bindingString, parentBindTo) {
    var result = bindingString;
    var parentBindToTokens = parentBindTo.split(".");
    result = result.replace("{parent}", "");

    //replacing "../"
    result = result.replace(/\.\.\//g, () => {
        parentBindToTokens.pop();
        return "";
    });

    if (result) {
        result = parentBindToTokens.join(".") + "." + result;
    } else {
        result = parentBindToTokens.join(".");
    }

    return result;
}

function resolveItemBinding(bindingString = "", index) {
    var result = bindingString;

    if (result.match(/\.item$/g) || result.match(/\.item\./g)) {
        //check for a number
        if (typeof index === "number") {
            result = result.replace(/item/g, index.toString());
        } else {
            WEBUILogs.error("Missing item's index for resolving.");
        }
    }

    return result;
}

function resolveDynamicItemsFromImmutableData(bindingString = "", index, widgetImmutableData) {
    var result = bindingString;
    var headRegEx;
    var head;
    var dynamicItemClass;

    if (!result.includes("{dynamicItem}") || !widgetImmutableData) {
        return result;
    }

    headRegEx = /(.*)\.\{dynamicItem\}/g;
    head = headRegEx.exec(result)[1];

    //console.log(head);
    var immutableState = findInWidgetState(widgetImmutableData, head.split("."));

    if (!immutableState) {
        WEBUILogs.error("Failed dynamic class binding for " + result);
        WEBUILogs.error(
            `Possible collecion inside collection situation.
             Parent collection item no longer binded.`
        );
    } else {
        dynamicItemClass = immutableState.getIn(["entities", index, "class", 0]);
    }

    if (!dynamicItemClass) {
        WEBUILogs.error("failed dynamic class item generation " + bindingString);
    }

    result = result.replace("{dynamicItem}", dynamicItemClass);

    return result;
}

//resolves {dynamicItem}
//uses first class[0] name of data entity
function resolveDynamicItemsFromJSONData(bindingString, index, itemClassifier) {
    var result = bindingString;
    var dynamicItemClass = itemClassifier;

    if (!result.includes("{dynamicItem}")) {
        return result;
    }

    if (!dynamicItemClass) {
        WEBUILogs.error("Unresolved binding string for " + bindingString);
        WEBUILogs.error("Missing itemClassifier.");
        return result;
    }

    result = result.replace("{dynamicItem}", dynamicItemClass);

    return result;
}

// Used for resolving configuration / data bindings for 'items' configuration array with regular expressions.
export const resolveItemRegexpBinding = function(item, entity) {
    // The regular expression needed for matching is the string between to 2 forward slashes. Using grouping the
    // regular expression is being extracted.
    let regexp = /(\/)(.*)(\/)/g;
    let regexpMatch = regexp.exec(item.bindTo);
    // If there is a group match a new regular expression object is created
    let extractRegularExpression = regexpMatch ? regexpMatch[2] : false;
    if (!extractRegularExpression) {
        return false;
    }
    let matchingExpression = new RegExp(extractRegularExpression, "g");
    let matchFound = entity.match(matchingExpression);
    // If the entity class ID matches the configuration object's bindTo regular expression,
    // the regular expression of the bindTo property is been replaced with the class ID of the entity.
    if (matchFound) {
        // The configuration object is being copied so that the items array remains unchanged.
        let resolvedItem = Object.assign({}, item);
        resolvedItem.bindTo = resolvedItem.bindTo.replace(/\/.*\//g, entity);
        return {
            item: resolvedItem
        };
    } else {
        return false;
    }
};

export const resolveItemsBinding = function(items = [], entityId) {
    for (let j = 0; j < items.length; j++) {
        let item = items[j];
        // Resolve regular expression matching. If a match is found edit the bindTo property of the
        // copied configuration object.
        let resolvedItem = resolveItemRegexpBinding(item, entityId);
        if (resolvedItem) {
            return resolvedItem.item;
        }
    }
};
